// Who sees the sidebar's Cannabis row (PRD 111 §4.1) — the one rule, read by
// moduleNavAccess the way field service's is.

import type { BusinessRole } from '../../../types/businessApi';
import type { BusinessModulesState, ModuleNavAccess } from '../../../services/businessModulesStore';

/** The roles the cannabis api answers at all (§4.11); every other role gets 403. */
export const CANNABIS_NAV_ROLES: readonly BusinessRole[] = ['owner', 'accountant', 'bookkeeper'];

/**
 * The sidebar's answer for the Cannabis row.
 *
 *   - Unknown draws nothing: the row ADDS a paid, unreleased module, so a wrong
 *     guess would advertise it to everyone (businessModulesStore).
 *   - A role the api refuses draws nothing, rather than a row to a 403.
 *   - A holder sees it.
 *   - So does a business restricted to marijuana that no longer holds it. Only
 *     the module's set-up writes the restriction and nothing clears it on
 *     lapse, so this is "set up, now lapsed": its records stay reachable,
 *     read-only, behind the gate's banner (PRD 42 Rule 4).
 *   - Nobody else: a cannabis business must buy the module (Dave, 2026-10-01),
 *     so there is no upsell row and no front door.
 */
export function cannabisNavAccess(state: BusinessModulesState): ModuleNavAccess {
  if (!state.modules) return 'none';
  if (!state.role || !CANNABIS_NAV_ROLES.includes(state.role)) return 'none';
  if (state.modules.cannabis === true) return 'all';
  return state.restrictedIndustry === 'marijuana' ? 'all' : 'none';
}
